import { useLayoutEffect, useState, type RefObject } from 'react';

// Whether a text fits on one line within the line's reserved width, measured from
// the rendered width rather than a character count. The measure sits in the line's
// content box, which spans the reserved width
export function useFitsLine(
  measureRef: RefObject<HTMLElement | null>,
  text: string
): boolean {
  const [fits, setFits] = useState(true);
  useLayoutEffect(() => {
    const measure = measureRef.current;
    const line = measure?.parentElement;
    if (!measure || !line) return;
    const check = () => setFits(measure.offsetWidth <= line.clientWidth);
    check();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(check);
    observer.observe(line);
    return () => observer.disconnect();
  }, [measureRef, text]);
  return fits;
}
